import React from 'react';
import PageTemplate from '../../components/PageTemplate';
const GenAI = () => {
  return <PageTemplate title="Generative AI" subtitle="Next-Gen AI Solutions" breadcrumb="AI & Data > Generative AI"><div className="content-section"><p>LLM integration, content generation, and generative AI solutions.</p></div></PageTemplate>;
};
export default GenAI; 